import FadeInLeft from "./FadeInLeft";

export default FadeInLeft;
